import { css } from "@emotion/css";
import { space, color, themeTokens, borderRadius, textStyles } from "@octopusdeploy/design-system-component-tokens";
import { resetStyles } from "../../utils/resetStyles";

export const navigationBarItemStyles = css({
    ...resetStyles.anchor,
    ...textStyles.nav.tab.label,

    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    transitionTimingFunction: "ease-in-out",
    transitionProperty: "background-color, outline, color",
    transitionDuration: "0.2s",

    height: "2.5rem",

    borderRadius: borderRadius.medium,

    paddingInlineStart: space[4],
    paddingInlineEnd: space[4],

    color: themeTokens.color.text.navigationBar.link.base,
    background: themeTokens.color.background.navigationBar.link.base,
    outline: "transparent solid 3px",

    "&[aria-current=page]": {
        color: themeTokens.color.text.navigationBar.link.selected,
        background: themeTokens.color.background.navigationBar.link.selected,
    },
    ":focus-visible": {
        color: themeTokens.color.text.navigationBar.link.focus,
        background: themeTokens.color.background.navigationBar.link.focus,
        outline: `${color.scale.blue[400]} solid 3px`,
        zIndex: 1,
    },
    ":hover": {
        color: themeTokens.color.text.navigationBar.link.hover,
        background: themeTokens.color.background.navigationBar.link.hover,
    },
    ":active": {
        color: themeTokens.color.text.navigationBar.link.active,
        background: themeTokens.color.background.navigationBar.link.active,
    },
});
